import { stdObject } from "../../../../data/types/stdObject";
import { colors } from "../../../../data/colors";
import { getRealCode } from "../../../../utils/getRealCode";
import SearchModule from "./SearchModule";
import { useTranslation } from "react-i18next";
import SortIcon from "@mui/icons-material/Sort";
import { useStructureContext } from "../../../../context/StructureContext";

export default function SearchItem({
  data = {},
  sortList = null,
}: {
  data?: stdObject;
  sortList?: stdObject | null;
}) {
  const { type, section } = useStructureContext();
  const { t } = useTranslation();
  const sectionColor = colors[type];
  return (
    <div className="searchBox" style={{ border: `solid 1px ${sectionColor}` }}>
      {(data.TITCAB === 1 || sortList) && (
        <div className="searchTitle" style={{ backgroundColor: sectionColor }}>
          {sortList ? (
            <SortIcon style={{ fontSize: 18 }} />
          ) : (
            t(`c.${getRealCode(data.CODCAB, section.code)}`)
          )}
        </div>
      )}
      <SearchModule data={data} sortList={sortList} />
    </div>
  );
}
